<template lang="html" src="./safety.section.html"></template>
<style lang="scss" scoped src="./_safety.section.mobile.scss"></style>
<style lang="scss" scoped src="./_safety.section.desktop.scss"></style>

<script>
export default {
  name: "SafetySection",
  props: ["isActive", "isLearnMoreActive"],
  methods: {
    openLearnMore() {
      if (!this.isLearnMoreActive) {
        this.$emit("learn-more", "safety");
      }
    },
    closeLearnMore() {
      this.$emit("learn-more", "main");
    }
  }
};
</script>
